import React, { useState} from "react";
import styles from './matrix.module.css';
import Grid from '@mui/material/Unstable_Grid2';
import Header from '../matrix_page_main_components/Header/Header.jsx';
import Footer from '../matrix_page_main_components/Footer/Footer.jsx';
import MatrixDisplayArea from '../matrix_page_main_components/MatrixDisplayArea/MatrixDisplayArea.jsx';
import UpcomingSessionPanel from '../matrix_page_main_components/UpcomingSessionPanel/UpcomingSessionPanel.jsx';
import CategorySelectionPanel from '../matrix_page_main_components/CategorySelectionPanel/CategorySelectionPanel.jsx';
import FeedbackPanel from '../matrix_page_main_components/FeedbackPanel/FeedbackPanel.jsx';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

import { Link } from "react-router-dom";

import Avatar from '@mui/material/Avatar';

import { CiSearch } from "react-icons/ci";
import { Category } from "@mui/icons-material";

import { useAuth } from '../global_state_components/AuthProvider.jsx';

import { useGlobalState } from '../global_state_components/GlobalStateProvider.jsx';
import FriendsPanel from "../matrix_page_main_components/FriendsPanel/FriendsPanel.jsx";


function Matrix() { 
  const { isAuthenticated, logout } = useAuth();    //Defined in AuthProvider.jsx

  const {isMobile} = useGlobalState();

  const navigate = useNavigate();    //Use the useNavigate hook to programmatically navigate to another route in response to an event (like a button click).

  const [isSidePanelExpanded, setIsSidePanelExpanded] = useState(false); 

  function toggleSidePanel(){
    if (isSidePanelExpanded===true){
      setIsSidePanelExpanded(false);
    }else if(isSidePanelExpanded===false){
      setIsSidePanelExpanded(true);
    }
  }

  return (
    <div className={styles.matrix}>

      <Header toggleSidePanel={toggleSidePanel}/>

      {/*---------------------------------*/}

      {isMobile?(
        /* <Grid container spacing={0} className={styles.matrix_main_grid}> */

        /*When making for phone we might have to add the side panel expansion button here.*/
        /*<Grid xs={2} className={styles.left_side_panel_grid ${isMobile ? {styles.left_side_panel_grid_z_index' : null} `}>*/
          /*
          <Grid xs={isSidePanelExpanded?6:0} className={styles.left_side_panel_grid}>    {/2/}
            <UpcomingSessionPanel/>
            <CategorySelectionPanel/>
            <FriendsPanel/>
            <FeedbackPanel/>
          </Grid>
          <Grid xs={isSidePanelExpanded?6:12} className={styles.calendar_main_grid}>     {/10/}
            <MatrixDisplayArea/>
          </Grid>
          */
      
        /* </Grid> */


          
          isSidePanelExpanded?(
            <Grid container spacing={0} className={styles.matrix_main_grid}>
              <Grid xs={6} className={styles.left_side_panel_grid}>    {/*2*/}
                <UpcomingSessionPanel/>
                <CategorySelectionPanel/>
                <FriendsPanel/>
                <FeedbackPanel/>
              </Grid>
              <Grid xs={6} className={styles.matrix_display_area_grid}>     {/*10*/}
                <MatrixDisplayArea/>
              </Grid>
            </Grid>
            ):(
            <Grid container spacing={0} className={styles.matrix_main_grid}>

              <Grid xs={12} className={styles.matrix_display_area_grid}>     {/*10*/}
                <MatrixDisplayArea/>
              </Grid>

            </Grid>
          )
          


        ):(


        <Grid container spacing={0} className={styles.matrix_main_grid}>
        {/*When making for phone we might have to add the side panel expansion button here.*/}
        {/*<Grid xs={2} className={{styles.left_side_panel_grid ${isMobile ? {styles.left_side_panel_grid_z_index' : null} `}>*/}

          <Grid xs={2} className={styles.left_side_panel_grid}>    {/*2*/}
            <UpcomingSessionPanel/>
            <CategorySelectionPanel/>
            <FriendsPanel/>
            <FeedbackPanel/>
          </Grid>
          <Grid xs={10} className={styles.matrix_display_area_grid}>     {/*10*/}
            <MatrixDisplayArea/>
          </Grid>

        </Grid>

        )
      }

      {/*---------------------------------*/}
      
      {/* 
      <Footer/>
      */}
      
    </div>
  );
  
}

export default Matrix;